import { Component, ViewChild } from '@angular/core';
import { AuthService } from '../../../shared/auth/auth.service';
import { I18NService } from '../../../shared/i18n/i18n.service';
import { Globals } from '../../../globals';
import { ItemTagType } from '../../tag/Tag';
import { TagService } from '../../tag/Tag.service';
import { IPlaceValuelistService } from '../../../iPlace/iPlace-valuelist.service';
import { TankService } from '../Tank.service';


@Component({
  selector: 'app-tank-levels',
  templateUrl: './tank-levels.component.html',
  styleUrls: ['./tank-levels.component.css']
})
export class TankLevelsComponent {

  dropdownList: any = [];
  selectedItems: any = [];
  itemTags: any[] = [];
  items: any[] = [];
  iPlaceList: any[] = [];
  iPlaceMap: any[];
  tanksMap: any[];
  isLoading = false;
  dropdownSettings: any = {};

  @ViewChild('multiSelect', { static: true }) element;

  constructor(private i18nService: I18NService,
              private authService: AuthService,
              private tagService: TagService,
              private iPlaceValuelistService: IPlaceValuelistService,
              private tankService: TankService,
              private globals: Globals) {
      this.isLoading = true;

      if ( (<any> Object).values(this.iPlaceValuelistService.getValuelist()).length ) {
        this.iPlaceList = (<any>  Object).values(this.iPlaceValuelistService.getValuelist())
          .sort((a: any, b: any) => a.iPlaceName.localeCompare(b.iPlaceName));
        this.iPlaceMap = this.iPlaceList.reduce((previous: any, current: any) => {
          previous[current.id] = current;
          return previous;
        }, {});
        this.getStoreTankLevels();
      } else {
        this.iPlaceValuelistService.reload()
          .then( () => {
            this.iPlaceList = (<any> Object).values(this.iPlaceValuelistService.getValuelist())
              .sort((a:any, b:any) => a.iPlaceName.localeCompare(b.iPlaceName));
            this.iPlaceMap = this.iPlaceList.reduce((previous: any, current: any) => {
              previous[current.id] = current;
              return previous;
            }, {});
            if ( globals.tenant == "ecomanager" ) {
              this.setGroupedIPlaceList();
            } else {
              this.dropdownList = this.iPlaceList;
            }
            this.getStoreTankLevels();
          });
      }

      let iPlaceSelectorText = i18nService.get("selectiPlaces");
      let groupBy = null;

      if ( globals.tenant == "ecomanager" ) {
        iPlaceSelectorText = i18nService.get("selectStation");
        groupBy = "tag";
        this.tagService.getItemTags(ItemTagType.IPLACE)
          .then( itemTags => {
            this.itemTags = itemTags;
            this.setGroupedIPlaceList();
          });
      } else {
        this.dropdownList = this.iPlaceList;
      }

      this.dropdownSettings = {
        singleSelection: false,
        primaryKey: 'idiPlace',
        labelKey: 'iPlaceName',
        selectAllText: i18nService.get("selectAll"),
        unSelectAllText: i18nService.get("unselectAll"),
        filterSelectAllText: i18nService.get("selectAllFiltered"),
        filterUnSelectAllText: i18nService.get("unselectAllFiltered"),
        noDataLabel: i18nService.get("noResults"),
        text: iPlaceSelectorText,
        searchPlaceholderText: i18nService.get("search"),
        badgeShowLimit: 2,
        enableSearchFilter: true,
        enableCheckAll: false,
        groupBy: groupBy,
        classes: "form-angular2-multiselect"
      };
  }

  onItemSelect(item: any) {
    this.reloadItems();
  }

  onSelectAll(items: any) {
    this.selectedItems = items;
    this.reloadItems();
  }

  private getStoreTankLevels()  {
    let data = localStorage.getItem("tank_levels_"+ this.authService.getUserID());
    if( data ) {
      this.items = JSON.parse(data)
          .filter(item => this.iPlaceList.findIndex(iPlace => iPlace.idiPlace == item.idiPlace) != -1);
      this.selectedItems = this.items.map(item => this.iPlaceMap[item.id]);
    }
      this.setTankLevels();

  }

  private setStoreTankLevels() {
    localStorage.setItem("tank_levels_"+ this.authService.getUserID(), JSON.stringify(this.items));
  }

  private setGroupedIPlaceList() {
    if ( this.iPlaceMap ) {
      this.itemTags.forEach(itemTag => {
        let iplace = this.iPlaceMap[itemTag.id.itemId];
        if ( iplace && !iplace.tag ) {
          iplace.tag = itemTag.id.tagKey;
        }
      });
    }

    if ( this.iPlaceList.length ) {
      if ( !this.itemTags || !this.itemTags.length ) {
        this.element.settings.groupBy = false;
      }
    }

    this.dropdownList = this.iPlaceList.sort((a:any, b:any) => {
      if ( !a.tag ) {
        return -1
      } else if (a.tag == b.tag) {
        return a.iPlaceName.localeCompare(b.iPlaceName);
      } else {
        return a.tag.localeCompare(b.tag);
      }
    });
  }

  private reloadItems() {
    this.items = this.items.filter(item => this.selectedItems.findIndex(selected => selected.idiPlace == item.idiPlace) != -1);
    let newItems = this.selectedItems.filter(selected => this.items.findIndex(item => selected.idiPlace == item.idiPlace) == -1);
    this.items.push(...newItems);

    this.setTankLevels();
  }

  private setTankLevels() {
    this.isLoading = true;
    let iPlaceIds = this.selectedItems.map(iplace => iplace.idiPlace)
      .join(";");
    if(iPlaceIds.length > 0) {
      this.tankService.getTanks(iPlaceIds).then(response => {
        this.isLoading = false;

        response.sort((a, b) => a.localTankId < b.localTankId ? -1 : a.localTankId > b.localTankId ? 1 : 0);

        this.tanksMap = response.reduce(function(map, tank) {
          if(tank.productId != null){
            map[tank.iPlaceId] = map[tank.iPlaceId] || [];
            map[tank.iPlaceId].push(tank);
          }
          return map;
        }, {});

        this.setStoreTankLevels();
      })
        .catch(error => {
          this.isLoading = false;
        })
    } else {
      this.setStoreTankLevels();
      this.tanksMap = [];
      this.isLoading = false;
    }
  }
}
